module.exports = __webpack_public_path__ + "img/Delete - Light Gray.64679683.png";